export const Trans_eng = {
	'chapter_abbr': 'CH',
	'scene_abbr': 'SCN',
	'minute_abbr': 'MIN',
	'location_studio_abbr': 'loc/std',
	'exterior_interior_abb': 'Ext/int',
	'day_night_abb': 'Day/Night',
	'projectd_minutes_abb': 'proj min',
	'prod_minutes_abb': 'prod min',
	'projected_abb': 'proj',
	'produced_abb': 'prod',
	'produced_scenes_abbr': 'prod scn',
	'produced_protection_abbr': 'prod prot',
	'average_abbr': 'Prom',
	'pending_abbr': 'Pend',
	'protections_abbr': 'Prot',
	'locations_abbr': 'Loc',
	'received_abb': 'rec',
	'cancel_abb': 'can',
	'difference_abb': 'diff',
	'cummulative_difference_abb': 'diff',
	'assigned_abb': 'asg',
	'budget_abb': 'bud',
	'retakes_abb': 'rep',
	'non_effective_abb': 'non eff',
	'effective_abb': 'eff',
	'budget_chapters_abb': 'bud chp',
	'budget_scenes_abb': 'bud scn',
	'budget_minutes_abb': 'bud min',
	'effective_difference_abb': 'eff diff',
	'cum_projected_abb': 'proj',
	'cum_received_abb': 'rec',
	'cum_difference_abb': 'diff',
	'cum_chapters_projected_abb': 'ch proj',
	'cum_chapters_received_abb': 'ch rec',
	'cum_chapters_difference_abb': 'ch diff',
	'scenes_assigned_abb': 'asg scn',
	'scenes_produced_abb': 'prod scn',
	'produced_minutes_abb': 'prod min',
	'Privados': 'Private',
	'Abiertos': 'Open',
	'Cerrados': 'Closed',
	'Cancelados': 'Cancelled',
	'daily_produced_scenes_average_abb': 'p scn day',
	'cancelada': 'cancel',
	'camera position': 'position',
	'$submit': 'submit',
	'plan no tiene submit': 'This daily plan has not submit',
	'no existen pĺanes': 'No daily plan found',
	'$week_initial': 'W'
}